import React from 'react';
import BaseInput, { InputWrap } from './BaseInput';
import Label from './Label';
import FormElement from './FormElement';

const Select = BaseInput.withComponent('select');

export default function StyledInputSelect(props) {
	return (
		<FormElement>
			<Label>{props.label}</Label>
			<InputWrap>
				<Select
					name={props.name}
					value={props.value}
					onChange={props.onChange}
					onBlur={props.onBlur}
				>
					{props.select.map(select => {
						return (
							<option key={select.value} value={select.value}>
								{select.name}
							</option>
						);
					})}
				</Select>
			</InputWrap>
		</FormElement>
	);
}
